import styled from "styled-components"

const CustomArrows = styled.button`
  border: none;
  background-color: ${(props) => props.theme.b_color_gradients.b_dark}CC;
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { CustomArrows }
